import type { PreviewIntegration } from '@/modules/Workspaces/KnowledgeHub/Integrations/integrationTypes'
import PitchbookLogo from './PitchbookLogo.vue'

export const pitchbookIntegration: PreviewIntegration = {
  id: 'pitchbook',
  name: 'PitchBook',
  description:
    "Access financial data on private and public markets from PitchBook to supercharge your AI's insights.",
  icon: PitchbookLogo,
}
